import request from '@/axios'

// 获取用户反馈列表
export function getUserFeedBackList(params) {
  console.log("获取用户反馈列表", params);
  return {
    "code": 0,
    "page": {
      "totalCount": 79,
      "pageSize": 10,
      "totalPage": 8,
      "currPage": 1,
      "list": [
        {
          "id": "1541",
          "burialPoint": "1001",
          "aid": "happytest",
          "productName": "Android电视",
          "uid": "10000000355151",
          "hid": "1AE6EB69BD0FBC25F7C72B84E8DB6076C",
          "roomid": null,
          "code": null,
          "ct": null,
          "mac": "020200000000",
          "cid": null,
          "unitType": "LLY-AN00",
          "manufacturer": "HONOR",
          "chipName": "c2.mtk.avc.decoder",
          "sysv": "34",
          "appv": "1.0.0",
          "sdkv": "60095-35312",
          "ls": "000000000000",
          "et": "100102700",
          "userid": null,
          "pn": null,
          "context": null,
          "logfileurl": "https://test01-logu.hpplay.cn/logupload/1/2025-08-28/10000000355151_2025-08-28_18-45-07_14.zip",
          "createTime": "2025-08-28 18:45:07.0",
          "monthList": null,
          "video": null,
          "images": null,
          "euqid": "A_10000000355151_1756377903158"
        },
        {
          "id": "1540",
          "burialPoint": "1001",
          "aid": "TV版产品测试渠道",
          "productName": "Android电视",
          "uid": "10000000157509",
          "hid": "19EDDB2D51C35853FEE7EE5B29EA2A37E",
          "roomid": null,
          "code": null,
          "ct": null,
          "mac": "4846C13B502C",
          "cid": null,
          "unitType": "TX6",
          "manufacturer": "Allwinner",
          "chipName": "OMX.allwinner.video.decoder.avc",
          "sysv": "24",
          "appv": "8.19.20",
          "sdkv": "60102-36700",
          "ls": "1756377296",
          "et": "",
          "userid": null,
          "pn": "13871436069",
          "context": null,
          "logfileurl": "https://test01-logu.hpplay.cn/logupload/1/2025-08-28/10000000157509_2025-08-28_18-35-17_10658.zip",
          "createTime": "2025-08-28 18:35:17.0",
          "monthList": null,
          "video": null,
          "images": null,
          "euqid": "A_10000000157509_1756377296073"
        }
      ]
    }
  }
  // return request({
  //   url: '/admin/userFeedBack/list',
  //   method: 'get',
  //   params
  // })
}

// 获取用户反馈详情
export function getUserFeedBackDetail(id) {
  return request({
    url: `/admin/userFeedBack/detail/${id}`,
    method: 'get'
  })
}

// 更新用户反馈状态
export function updateUserFeedBackStatus(data) {
  return request({
    url: '/admin/userFeedBack/updateStatus',
    method: 'post',
    data
  })
}

/** 获取客户端类型 */
export const getClientType = () => {
  return request({
    url: "/lebo-system/dict-biz/list",
    method: "get",
    params: {
      code: "client_types"
    }
  });
};

/** 获取版本列表 */
export function getVersionListByChanelid (data) {
  // return request({
  //   url: "/tvapp/reported/version-list",
  //   method: "get",
  //   params: data
  // });
  console.log("获取版本列表", data);
  return {
    "code": 0,
    "list": [
        "",
        "10",
        "109",
        "11",
        "110",
        "111",
        "122"
    ]
  }
}

/** 获取问题类型列表 */
export const getEtList = (data) => {
  return request({
    url: "/tvapp/reported/et-options",
    method: "get",
    params: data
  });
};

